<template>
  <div>
    <div v-if="isLoading" class="loader">
      <v-row v-for="index in 3" :key="index">
        <v-col cols="12">
          <v-skeleton-loader type="list-item-three-line" style="border-bottom: 3px solid #e0e0e0;"></v-skeleton-loader>
        </v-col>
      </v-row>
    </div>

    <div v-if="!isLoading && appointments.length === 0" class="no-appointments">
      <img style="height: 180px; filter: grayscale(1); opacity: 0.6;" :src="require('@/assets/no_budget.png')">
      <h3>Sem agendamentos cadastrados</h3>
      <small>Altere algum dos filtros para buscar novamente ou <br/> tente novamente mais tarde.</small>
    </div>

    <div class="list-container">
      <LazyList :items="this.appointments" @load-more="loadMoreData" :has-more-data="hasMoreAppointments">
        <template v-slot:default="{ items }">
          <div @click="select(appointment)" v-for="appointment in items" :key="appointment.id" class="al-compromise">
            <div class="c-title"><b>{{ getDate(appointment.forecast) }} | {{ appointment_status[appointment.status] }} | </b> {{ appointment.title }}</div>
            <div v-if="appointment.observation" class="c-description">{{ appointment.observation }}</div>
            <div class="c-responsibles">Prioridade: <b>{{ getAppointmentPriority(appointment.priority) }}</b> | Responsável: <b>{{ getAppointmentResponsibles(appointment.appointment_responsibles) }}</b></div>
          </div>
        </template>
      </LazyList>
    </div>

  </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import dayjs from "dayjs";

import LazyList from "@/components/Common/LazyList";

export default {
  emits: ['select', 'load-more'],
  props: {
    appointments: {
      type: Array,
      default: () => [],
    },
    hasMoreData: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    LazyList,
  },
  data() {
    return {
      isLoading: false,
      hasMoreAppointments: false,
      appointment_status: {
        confirmed: 'CONFIRMADO',
        canceled: 'CANCELADO',
        waiting_confirm: 'AGUARDANDO CONFIRMAÇÃO',
        created: 'CRIADO'
      }
    }
  },
  watch: {
    hasMoreData: {
      immediate: true,
      handler(hasMoreData) {
        this.hasMoreAppointments = hasMoreData;
      },
    },
  },
  methods: {
    select(appointment) {
      this.$emit('select', appointment);
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString();
    },
    loadMoreData() {
      if (this.hasMoreAppointments && !this.isLoading) {
        this.$emit('load-more');
      }
    },
    getAppointmentPriority(priority) {
      const priorities = [
        { value: 'little_urgent', text: 'Pouco urgente' },
        { value: 'priority', text: 'Prioritária' },
        { value: 'important', text: 'Importante' },
        { value: 'critical', text: 'Crítico' },
      ];

      const priorityObj = priorities.find((p) => p.value === priority);
      return priorityObj ? priorityObj.text : '';
    },
    getAppointmentResponsibles(responsibles) {
      if (responsibles.length === 0) {
        return "Não especificado";
      }
      return responsibles.map(responsible => responsible.user.name).join(' / ');
    },
    getDate(date) {
      return dayjs(date).locale('pt-br').format("DD/MM/YYYY HH:mm");
    },
  },
}
</script>

<style lang="scss" scoped>
  .no-appointments {
    text-align: center;
    padding: 20px;
    color: #a6a4a4;
  }

  .list-container {
    width: -webkit-fill-available;
    margin-bottom: 80px;

    .al-compromise {
      cursor: pointer;
      border: 1px solid rgb(197, 197, 197);
      border-radius: 6px;
      margin: 0 24px 15px 24px;

      .c-title {
        padding: 10px;
        background-color: #eee;
        font-size: 15px;
      }

      .c-description {
        padding: 10px;
        border-bottom: 2px solid #ebebeb;
      }

      .c-responsibles {
        padding: 10px;
        font-size: 13px;
      }
    }
  }
</style>
